import { useSelectedCompanyStore } from '../../stores/selectedCompany.store';
import { useUserCompaniesStore } from '../../stores/userCompanies.store';
import { SubscriptionStatus } from '@monorepo/shared';

interface PaywallState {
  isPaywalled: boolean;
  companyName?: string;
}

export const useIsCompanyPaywalled = (): PaywallState => {
  const selectedCompanyId = useSelectedCompanyStore((state) => state.selectedCompanyId);
  const companies = useUserCompaniesStore((state) => state.companies);
  const selectedCompany = companies.find((company) => company.id === selectedCompanyId);

  if (!selectedCompany) {
    return { isPaywalled: false };
  }

  return {
    isPaywalled: selectedCompany.subscriptionStatus !== SubscriptionStatus.ACTIVE,
    companyName: selectedCompany.legalName,
  };
};
